<template>
    <v-card>
        <v-data-table
            :items="getLedgerControlsData && getLedgerControlsData.data ? getLedgerControlsData.data : []"
            :headers="headers"
            class="elevation-1"
            dense
            :search="search"
        >
            <template #top>
                <v-card-title>
                    <slot></slot>
                </v-card-title>
                <v-text-field
                    v-model="searchQuery"
                    clearable
                    dense
                    hide-details
                    color="teal"
                    label="Search"
                    style="margin: 0 13px 5px 13px"
                    :append-icon="mdiMagnify"
                    @keyup.enter="search = searchQuery"
                    @click:append="search = searchQuery"
                    @click:clear="search = ''"
                />
            </template>
            <template #[`item.CNTRL_N`]="{ item }">
                <v-chip style="font-weight: 600;">
                    {{ item.CNTRL_N }}
                </v-chip>
            </template>
            <template #[`item.GEN_DATE`]="{ item }">
                {{ formatDate(item.GEN_DATE) }}
            </template>
            <template #[`item.ACTIONS`]="{ item }">
                <v-btn
                    :loading="loading && item.CNTRL_N == currentDownload"
                    small
                    color="teal"
                    class="white--text"
                    @click="download(item.CNTRL_N)"
                >
                    <v-icon>{{ mdiDownload }}</v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mdiDownload, mdiMagnify } from '@mdi/js'
import { saveAs } from 'file-saver'
import { moment } from '../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import { base64ToBlob } from '../../../utils/helpers'

export default {
    props: ['providerId'],
    data: () => ({
        mdiDownload,
        mdiMagnify,
        search: null,
        searchQuery: null,
        loading: false,
        currentDownload: null,
        headers: [
            { text: 'Control Number', value: 'CNTRL_N' },
            { text: 'Generated By', value: 'GEN_BY' },
            { text: 'Generated Date', value: 'GEN_DATE' },
            { text: 'Total', value: 'TOTAL' },
            { text: 'Actions', value: 'ACTIONS' }
        ]
    }),
    computed: {
        ...mapGetters(['getLedgerControlsData', 'downloadLedgerData'])
    },
    watch: {
        searchQuery(newVal) {
            if (newVal === '' || newVal === null || newVal === undefined)
                this.search = ''
        },
        providerId(newVal) {
            if (newVal && newVal.hosp_msu_code)
                this.getLedgerControls({ MSU_C: newVal.hosp_msu_code })
        },
        downloadLedgerData(newVal) {
            this.loading = false
            if (newVal && newVal.status === 200)
                this.handleFileDownload(newVal.data, this.currentDownload)
        }
    },
    methods: {
        ...mapActions(['getLedgerControls', 'downloadLedger']),
        formatDate(date) {
            return moment(date).format('MMM D, YYYY')
        },
        handleFileDownload(data, fileName) {
            try {
                const blob = base64ToBlob(data.file, data.type)
                saveAs(blob, fileName)
            } catch (error) {
                console.error('Failed to download ledger file:', error)
            }
        },
        download(CNTRL_N) {
            this.loading = true
            this.currentDownload = CNTRL_N
            this.downloadLedger({ MSU_C: this.providerId.hosp_msu_code, CNTRL_N })
        }
    }
}
</script>
